var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    _vm._b(
      {
        attrs: {
          value: _vm.value,
          filterable: "",
          clearable: "",
          remote: "",
          "remote-method": _vm.search,
          loading: _vm.loading,
          disabled: !_vm.available,
        },
        on: { change: _vm.change },
      },
      "el-select",
      _vm.$attrs,
      false
    ),
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: _vm.format(item), value: item.id },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }